import { render, staticRenderFns } from "./NutritionDetails.vue?vue&type=template&id=1258749a&scoped=true&lang=html&"
import script from "./NutritionDetails.vue?vue&type=script&lang=js&"
export * from "./NutritionDetails.vue?vue&type=script&lang=js&"
import style0 from "./NutritionDetails.vue?vue&type=style&index=0&id=1258749a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1258749a",
  null
  
)

export default component.exports